'use client';

import { useContext } from 'react';
import { SmartCaptchaContext } from '../components/SmartCaptchaProvider';

/**
 * Access the shared Yandex SmartCaptcha widget mounted in the root layout.
 * Returns `{ getCaptchaToken }` — call `await getCaptchaToken()` right before
 * submitting a form to get a fresh token to send along with the request.
 */
export function useSmartCaptcha() {
    const ctx = useContext(SmartCaptchaContext);
    if (!ctx) {
        throw new Error('useSmartCaptcha must be used within a SmartCaptchaProvider');
    }
    return ctx;
}

export default useSmartCaptcha;
